var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.482 11.851 4.023-4.022c1.333-1.334 2-2 2.828-2 .829 0 1.495.666 2.829 2l1.01 1.01c1.333 1.333 2 2 2 2.828 0 .828-.667 1.495-2 2.828l-3.987 3.987a18.834 18.834 0 0 1-6.703-6.63Zm-1.454 1.455L7.523 25.81c-.425.424-.638.637-.777.898-.14.261-.199.556-.317 1.145l-1.282 6.41c-.066.333-.1.5-.005.594.095.095.26.062.593-.005l6.41-1.282c.59-.118.885-.177 1.146-.316.261-.14.474-.353.899-.778L26.727 19.94a20.836 20.836 0 0 1-6.7-6.634Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageIcon);
export default __webpack_public_path__ + "static/media/add-image-icon.3ae33a1178511ac18b5ae4357ddf38a8.svg";
export { ForwardRef as ReactComponent };